import { Component, OnDestroy, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { VendorService } from '../../../services/vendor.service';
import { UntypedFormControl, FormControl } from '@angular/forms';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'app-vendor-auto-complete',
	templateUrl: './vendor-auto-complete.component.html',
	styleUrls: ['./vendor-auto-complete.component.scss']
})
export class VendorAutoCompleteComponent implements OnInit, OnDestroy {
	vendorSearch = new FormControl('');
	includeInactive = new FormControl(false);
	searching = false;
	loadsubscription: any = false;
	allResults: any[] = [];
	filteredItems: any[] = [];
	keys = 'supplierid,suppname';

	@Output() vendor_selected = new EventEmitter<any>();
	@Input() showIncludeInactiveToggle = true;

	private destroy$ = new Subject<void>();

	constructor(private globalSearchService: GlobalSearchService, public vendorService: VendorService) {}

	ngOnInit(): void {
		this.includeInactive.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
			this.reloadVendors();
		});
		this.reloadVendors();

		this.vendorSearch.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
			this.search();
		});
	}

	reloadVendors(): void {
		if (this.loadsubscription) {
			this.loadsubscription.unsubscribe();
		}
		this.searching = true;
		this.loadsubscription = this.vendorService.getVendorsPost({
			keywords: '',
			inc_disabled: !!this.includeInactive.value
		}).subscribe((results: any) => {
			this.searching = false;
			this.allResults = Array.isArray(results) ? results : [];
			this.search();
		});
	}

	search(): void {
		const raw = this.vendorSearch.value;
		if (raw === '' || raw == null) {
			this.filteredItems = this.allResults;
			this.vendor_selected.emit('');
			return;
		}
		if (typeof raw === 'object' && raw !== null && (raw as { supplierid?: unknown }).supplierid) {
			this.filteredItems = this.allResults;
			return;
		}
		this.filteredItems = this.globalSearchService.filterItem(this.allResults, raw, this.keys);
	}

	selectVendor(row: any): void {
		this.vendor_selected.emit(this.vendorSearch.value);
	}

	displayFn(vendor: any): string {
		if (!vendor) {
			return '';
		}
		return vendor.supplierid + '-' + vendor.suppname;
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
		if (this.loadsubscription && typeof this.loadsubscription.unsubscribe === 'function') {
			this.loadsubscription.unsubscribe();
		}
	}
}
